import { Type } from 'class-transformer';

import { PageModel as BasePageModel } from '@empathy/survey/base';

import { Question } from './question.model';

export class PageModel extends BasePageModel {
  @Type(() => Question)
  override questions: Question[];

  constructor(id: string = null) {
    super(id);
  }

  override get visibleQuestions(): Question[] {
    return this.questions.filter((question) => question.visible && !question.neverShow);
  }
}
